import { cn } from "@/lib/utils";
import type { SearchGameType } from "@/pages/search/types";

import GameTile from "./game-tile";

interface GamesProps {
  className?: string;
  games: SearchGameType[];
  onHover?(locationId: string | null): void;
  startIndex?: number;
  withoutCompany?: boolean;
  withoutLocation?: boolean;
  withoutPadding?: boolean;
}

export default function Games({
  className,
  games,
  onHover = () => {
    /* No-op */
  },
  startIndex = 1,
  withoutCompany = false,
  withoutLocation = false,
}: GamesProps) {
  const handleMouseEnter = (game: SearchGameType) => () =>
    onHover(game.gameLocation.id);

  const handleMouseLeave = () => onHover(null);

  return (
    <div
      className={cn(
        "flex flex-col items-stretch border-white/8 *:not-first:mt-2.5 *:not-first:border-white/8 *:not-first:border-t *:not-first:pt-2.5 md:border-b *:not-first:md:mt-0 *:not-first:md:pt-5",
        className
      )}
    >
      {games.map((game, index) => (
        <GameTile
          game={game}
          key={game.id}
          onMouseEnter={handleMouseEnter(game)}
          onMouseLeave={handleMouseLeave}
          searchResultsPosition={startIndex + index}
          withoutCompany={withoutCompany}
          withoutLocation={withoutLocation}
        />
      ))}
    </div>
  );
}
